import React from 'react';

export const CircleIconOhNoFace = (props: { color?: string }): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
      <g fill={props.color ?? 'currentColor'} fillRule="evenodd">
        <path
          fillRule="nonzero"
          d="M35.98 34.8c1.33 2.3-.13 3.54-2.14 4.7l-4.85 2.8c-2 1.16-3.8 1.8-5.14-.5s.13-3.54 2.14-4.7l4.85-2.8c2-1.16 3.8-1.8 5.14.5"
        />
        <path
          fillRule="nonzero"
          d="M27 0a27 27 0 1 1 0 54 27 27 0 0 1 0-54m0 4.5a22.5 22.5 0 1 0 0 45 22.5 22.5 0 0 0 0-45"
        />
        <path d="M15.5 24a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M30 23.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0" />
        <path
          stroke={props.color ?? 'currentColor'}
          strokeWidth="3"
          d="M22.5 12.28c-1.91-.61-1.91 1.05-5.23 1.05-3.31 0-5.23 1.75-5.23 5.06M32.3 12.28c1.9-.61 1.9 1.05 5.22 1.05s5.23 1.75 5.23 5.06"
        />
      </g>
    </svg>
  );
};
